import themes from '../../theming/themes.js';
import React, { memo, useContext } from 'react';
import CheckboxField from '../../components/Checkbox/_CheckboxField.js';
import _TableData from '../../components/Table/TableData.js';
import _TableHeaderCol from '../../components/Table/TableHeaderCol.js';
import _TableRow from '../../components/Table/TableRow.js';
import { v4 } from 'uuid';
import { selectRow, deselectRow } from './TableActions.js';
import TableContext from './TableContext.js';

var TableBodyRow = function TableBodyRow(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    index = _ref.index,
    isHoverable = _ref.isHoverable,
    theme = _ref.theme,
    dataTestId = _ref['data-testid'];
  var _useContext = useContext(TableContext),
    dispatch = _useContext.dispatch,
    isSelectable = _useContext.isSelectable,
    isRowSelected = _useContext.isRowSelected;
  var handleChange = function handleChange(e) {
    var checked = e.target.checked;
    var row = data._original;
    var action = checked ? selectRow(row) : deselectRow(row);
    dispatch(action);
  };
  return /*#__PURE__*/React.createElement(_TableRow, {
    isHoverable: isHoverable,
    key: index,
    theme: theme,
    "data-testid": dataTestId
  }, isSelectable ? /*#__PURE__*/React.createElement(_TableData, {
    theme: theme,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    hideLabel: true,
    label: "Row ".concat(index),
    field: "row-".concat(v4()),
    value: isRowSelected(data._original),
    onChange: handleChange,
    theme: theme
  })) : null, columns.map(function (column) {
    var children = column.Cell ? /*#__PURE__*/React.createElement(column.Cell, {
      data: data
    }) : data[column.accessor];
    return column.isHeaderColumn ? /*#__PURE__*/React.createElement(_TableHeaderCol, {
      key: column.id,
      theme: theme,
      headers: "".concat(column.id)
    }, children) : /*#__PURE__*/React.createElement(_TableData, {
      key: column.id,
      theme: theme,
      headers: "".concat(column.id)
    }, children);
  }));
};
var TableBodyRows = function TableBodyRows(_ref2) {
  var _ref2$columns = _ref2.columns,
    columns = _ref2$columns === void 0 ? [] : _ref2$columns,
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? [] : _ref2$data,
    isHoverable = _ref2.isHoverable,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    dataTestId = _ref2['data-testid'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, data.map(function (d, index) {
    return /*#__PURE__*/React.createElement(TableBodyRow, {
      "data-testid": dataTestId,
      isHoverable: isHoverable,
      columns: columns,
      data: d,
      key: index,
      index: index,
      theme: theme
    });
  }));
};
function isEqual(prevProps, nextProps) {
  var _prevProps$data = prevProps.data,
    prevData = _prevProps$data === void 0 ? [] : _prevProps$data;
  var _nextProps$data = nextProps.data,
    nextData = _nextProps$data === void 0 ? [] : _nextProps$data;
  if (prevData.length === nextData.length) {
    return prevData.every(function (item, idx) {
      return (
        // @ts-ignore;
        item._index === nextData[idx]._index
      );
    });
  }
  return false;
}
var TableBodyRows$1 = /*#__PURE__*/memo(TableBodyRows, isEqual);

export default TableBodyRows$1;
